import { type EmailTemplate } from '@/types/EmailTemplate'

export function createEmailTemplate(data: Partial<EmailTemplate> = {}): EmailTemplate {
  return {
    id: data.id || data.name || '',
    name: data.name || '',
    subject: data.subject || '',
    html: data.html || '',
    text: data.text,
    amp: data.amp,
    attachments: data.attachments || [],
    createdAt: data.createdAt || new Date(),
    updatedAt: data.updatedAt || new Date(),
    isDeleted: data.isDeleted || false,
  }
}
